import { render, staticRenderFns } from "./VozExpressionProfileSection.vue?vue&type=template&id=79828513"
import script from "./VozExpressionProfileSection.vue?vue&type=script&lang=ts"
export * from "./VozExpressionProfileSection.vue?vue&type=script&lang=ts"
import style0 from "./VozExpressionProfileSection.vue?vue&type=style&index=0&id=79828513&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports